/* @jsx jsx */
import { forwardRef } from 'react';
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { buttonContainerStyles, getContainerStyles, textStyles, iconColor, getIconStyles, getTextContainerStyles } from './styles';
import { FloatingContainer } from '../../components/FloatingContainer/FloatingContainer';
import Button from '@atlaskit/button/standard-button';
import messages from './messages';
import { AI_MODAL_SCREEN_CLASS } from '../../../utils/constants';
import { buttonAutoFocusRingFix } from '../../styles/focus';
export function ErrorMessage({
  children,
  breakpoint
}) {
  const {
    formatMessage
  } = useIntl();
  return jsx("div", {
    css: getTextContainerStyles(breakpoint)
  }, jsx("span", {
    css: getIconStyles(breakpoint)
  }, jsx(WarningIcon, {
    label: formatMessage(messages.warningIconLabel),
    primaryColor: iconColor
  })), jsx("p", {
    css: textStyles
  }, children));
}
export function ErrorButton({
  children,
  onClick,
  appearance,
  testId,
  autoFocus,
  disabled = false
}) {
  return jsx(Button, {
    css: buttonAutoFocusRingFix,
    autoFocus: autoFocus,
    testId: testId,
    spacing: "compact",
    onClick: onClick,
    type: "button",
    appearance: appearance,
    isDisabled: disabled
  }, children);
}
export function ErrorButtonContainer({
  children
}) {
  return jsx("div", {
    css: buttonContainerStyles
  }, children);
}

// Need to use forwardRef because functional component cannot be passed a ref
// as a prop.
export const ErrorFloatingContainer = /*#__PURE__*/forwardRef(({
  children,
  breakpoint
}, ref) => {
  return jsx(FloatingContainer, {
    ref: ref,
    "data-testid": "error-screen",
    className: `error-screen ${AI_MODAL_SCREEN_CLASS}`,
    css: getContainerStyles(breakpoint),
    paddingAdjustments: {
      top: 1,
      bottom: 1
    }
  }, children);
});